import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { Person } from '@/components/molecules/Person/Person'
import { PersonType } from '@/components/molecules/Person/Person.types'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { TeamTypes } from './types'
import * as styles from './TeamSection.module.css'

export function TeamSection({ title, subtitle, team }: TeamTypes) {
  return (
    <section
      className="flex items-center flex-col max-w-screen-desktop mx-auto p-24 netbook:px-90 netbook:py-64"
      id={kebabCase(title)}
    >
      <h2 className="text-headingM-mobile tablet:text-headingM font-bold text-text-dark-900 text-center mb-24">
        {title}
      </h2>
      <div className="text-bodyL text-text-dark-900 max-w-2xl text-center">
        {typeof subtitle === 'string' ? subtitle : <RichTextField data={subtitle} />}
      </div>
      <ul
        className={clsx(
          styles.list,
          'flex flex-wrap justify-center mobile:gap-x-[calc((min(768px,100vw)-48px-(2*250px))/2)] tablet:gap-x-[calc((min(800px,100vw)-48px-(2*250px))/2)] tablet-lg:gap-x-[calc((min(1024px,100vw)-48px-(3*250px))/2)] netbook:gap-x-[calc((min(1440px,100vw)-180px-(3*250px))/2)] mt-80'
        )}
      >
        {team.map((person: PersonType) => (
          <li key={person._uid}>
            <div>
              <Person image={person.image} name={person.name} role={person.role} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
